// Admin / PDF testIds
export const ADMIN = {
  loginRoot: "admin-login-root",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",

  dashboardRoot: "admin-dashboard-root",
  logoutBtn: "admin-logout-btn",
  tabContacts: "admin-tab-contacts",
  tabSubscribers: "admin-tab-subscribers",
  tabPdfLeads: "admin-tab-pdfleads",
  contactsTable: "admin-contacts-table",
  subscribersTable: "admin-subscribers-table",
  pdfLeadsTable: "admin-pdfleads-table",
  exportSubscribersCsv: "admin-export-subscribers-csv",
  contactRow: (id) => `admin-contact-row-${id}`,
  subscriberRow: (id) => `admin-subscriber-row-${id}`,
  pdfLeadRow: (id) => `admin-pdflead-row-${id}`,
  deleteContact: (id) => `admin-delete-contact-${id}`,
  deleteSubscriber: (id) => `admin-delete-subscriber-${id}`,
  deletePdfLead: (id) => `admin-delete-pdflead-${id}`,
};

export const PDF = {
  downloadHero: "pdf-download-hero",
  downloadTypes: "pdf-download-types",
  emailInput: "pdf-email-input",
  emailSubmit: "pdf-email-submit",
  emailSuccess: "pdf-email-success",
  emailRoot: "pdf-email-root",
};
